import '/assets/styles/partials/loader.scss';
import { Loader } from '@wearetla/tla-essentials-tools/partials/loader';
import classNames from 'classnames';

// `rich` modunda kullanılan, tarama hissi veren çok katmanlı gösterge.
const RichIcon = () => (
	<div className="loaderelem-richicon">
		<span className="richicon-ring" />
		<span className="richicon-ring second" />
		<span className="richicon-scanner" />
		<span className="richicon-dots">
			<i className="dots-dot" />
			<i className="dots-dot" />
			<i className="dots-dot" />
		</span>
	</div>
);

const StyledLoader = ({ solid, dark, small, light, rich, icon, className, ...props }) => {
	return (
		<Loader
			{...props}
			icon={icon ?? (rich ? <RichIcon /> : undefined)}
			className={classNames(className, { small, solid, dark, light, rich })}
		/>
	);
};

export default StyledLoader;
